import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { map, set, get, isEmpty } from "lodash";
import { withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import $ from "jquery";

import selectors from "./selectors";

import actions from "../../actions";
import { FormError } from "../../../../react/common/components";
import { rules } from "../../../../../common/validations";

const initialState = {
  submitIsClicked: false,
  errors: {},
  client: {
    name: "",
    status: "",
    creator: "",
  },
};

class CustomerForm extends React.Component {
  constructor() {
    super();

    this.state = {
      ...initialState,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validate = this.validate.bind(this);
  }

  componentDidMount() {
    const { getClient, id } = this.props;

    if (id) {
      getClient(id).then((r) => {
        this.setState({ client: r.result.data });
      });
    }
  }

  componentWillReceiveProps(newProps) {
    const { getClient, id } = this.props;
    if (id !== newProps.id) {
      if (newProps.id) {
        getClient(newProps.id).then((r) => {
          this.setState({ client: r.result.data });
        });
      } else {
        this.state = {
          ...initialState,
        };
      }
    }
  }

  handleInputChange({ target: { id, value } }) {
    let { client } = this.state;

    client = set(client, id, value);

    this.setState({ client }, () => this.validate());
  }

  // TODO:SREDI TITLOVE PO SVIM PAGEVIMA
  validate() {
    const {
      client: { name, status },
    } = this.state;

    const errors = {};

    if (rules.isEmpty(name)) {
      errors.name = "Please provide an Name";
    }
    if (rules.isEmpty(status)) {
      errors.status = "Please provide an status";
    }

    this.setState({ errors });
    return errors;
  }

  handleSubmit(event) {
    event.preventDefault();

    const { updateClient, createClient, id, reload } = this.props;
    const { client, errors } = this.state;

    this.setState({ submitIsClicked: !!errors });

    if (isEmpty(this.validate())) {
      if (id) {
        updateClient(id, client)
          .then(() => {
            toast.success("Success!");
            $(".close").click();
            reload();
          })
          .catch(({ response: { data } }) => {
            const errorMessage = get(data, "message", "Something went wrong!");
            toast.error(errorMessage);
          });
      } else {
        createClient(client)
          .then(() => {
            toast.success("Success!");
            $(".close").click();
            reload();
          })
          .catch(({ response: { data } }) => {
            const errorMessage = get(data, "message", "Something went wrong!");
            toast.error(errorMessage);
          });
      }
    }
  }

  render() {
    const { isClientLoaded, isSubmitting, id } = this.props;
    const { client, errors, submitIsClicked } = this.state;

    let content = null;

    if (isClientLoaded || !id) {
      const SelectRenderer = (props) => {
        const selectPlaceholder = !id ? (
          <option disabled label="-- select an option -- " />
        ) : null;

        const options = map(props.options, (option, key) => {
          const defaultValue = !id
            ? get(client, props.optionName) === option
            : null;

          return (
            <option defaultValue={defaultValue} key={key}>
              {option}
            </option>
          );
        });

        return (
          <select
            value={client[props.optionName]}
            className="custom-select"
            id={props.optionName}
            onChange={this.handleInputChange}
          >
            {selectPlaceholder}
            {options}
          </select>
        );
      };

      const creator = id ? (
        <div className="form-group">
          <label className="w-100 uppercase" htmlFor="creator">
            creator
            <input
              type="text"
              className="form-control mt-1"
              id="creator"
              aria-describedby="creator"
              disabled
              value={client.creator}
            />
          </label>
        </div>
      ) : null;

      content = (
        <form className="user-form" onSubmit={this.handleSubmit}>
          <div className="form-group">
            <label className="w-100 uppercase" htmlFor="name">
              Name
              <input
                type="text"
                className="form-control mt-1"
                id="name"
                aria-describedby="name"
                value={client.name}
                onChange={this.handleInputChange}
              />
              <FormError show={submitIsClicked} error={errors.name} />
            </label>
          </div>
          {creator}
          <div className=" col-12 d-flex justify-content-center my-3">
            <input
              type="submit"
              className="btn btn-primary"
              disabled={isSubmitting}
              value="Save"
            />
          </div>
        </form>
      );
    }

    return <React.Fragment>{content}</React.Fragment>;
  }
}

CustomerForm.defaultProps = {
  id: null,
};

CustomerForm.propTypes = {
  createClient: PropTypes.func.isRequired,
  getClient: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  isClientLoaded: PropTypes.bool.isRequired,
  updateClient: PropTypes.func.isRequired,
  reload: PropTypes.func.isRequired,
  id: PropTypes.string,
};

export default connect(selectors, { ...actions.client, ...actions.clients })(
  withRouter(CustomerForm)
);



// WEBPACK FOOTER //
// ./client/react/Admin/components/CustomerForm/index.jsx